import { useState, useEffect } from "react";
import "../../assets/css/SignupOtp/SignupOtp.css";
import emailjs from "emailjs-com";
import { useNavigate, Navigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL,EMAIL_SERVICE_ID,EMAIL_TEMPLATE_ID,EMAIL_PUBLIC_KEY } from "../../store/config";
import ErrorModal from "../../components/common/ErrorModal";



function SignupOtp() {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [error, setError] = useState(""); // For showing error messages
  const [showErrorModal, setShowErrorModal] = useState(false);

  // 🔐 OTP states
  const [otpSent, setOtpSent] = useState(false);

  // ✅ Custom authentication state
  const [isAuthenticated, setIsAuthenticated] = useState(
    sessionStorage.getItem("isLoggedIn") === "true"
  );

  const navigate = useNavigate();

  // ✅ Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard");
    }
  }, [isAuthenticated, navigate]);

  // 🔐 Generate OTP
  const generateOtp = () =>
    Math.floor(100000 + Math.random() * 900000).toString();

  // 🔐 Hash OTP
  const hashOtp = async (otp) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(otp);
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    return Array.from(new Uint8Array(hashBuffer))
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
  };

  // 📧 Send OTP Email (FE ONLY)
  const sendOtpEmail = async (otp) => {
    return emailjs.send(
      EMAIL_SERVICE_ID,
      EMAIL_TEMPLATE_ID,
      {
        email: email, // use the state
        passcode: otp,
      },
      EMAIL_PUBLIC_KEY
    );
  };

  // Email validation function
  // const isValidEmail = (email) => {
  //     const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //     return regex.test(email);
  // };

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  // Handle sending OTP
  const handleSendOtp = async () => {
    if (!email) {
      setError("Email is required!");
      setShowErrorModal(true);
      return;
    }

    if (!isValidEmail(email)) {
      setError("Please enter a valid email address!");
      setShowErrorModal(true);
      return;
    }

    try {
      const otpGenerated = generateOtp();
      const hashedOtp = await hashOtp(otpGenerated);

      // store hashed OTP
      sessionStorage.setItem("otpHash", hashedOtp);
      sessionStorage.setItem("otpExpiry", Date.now() + 2 * 60 * 1000);

      // send email
      await sendOtpEmail(otpGenerated);

      setOtpSent(true);
      setError(""); // clear any previous error
    } catch (err) {
      console.error(err);
      setError("Failed to send OTP. Try again.");
      setShowErrorModal(true);
    }
  };

  // Handle verifying OTP
  // const handleVerifyOtp = async () => {
  //     if (!otp) {
  //         setError("Please enter OTP!");
  //         return;
  //     }

  //     const storedHash = sessionStorage.getItem("otpHash");
  //     const expiry = sessionStorage.getItem("otpExpiry");

  //     if (!storedHash || Date.now() > expiry) {
  //         setError("OTP expired");
  //         return;
  //     }

  //     const enteredHash = await hashOtp(otp);

  //     if (enteredHash === storedHash) {
  //         sessionStorage.removeItem("otpHash");
  //         sessionStorage.removeItem("otpExpiry");

  //         // ✅ Mark user as authenticated
  //         sessionStorage.setItem("isLoggedIn", "true");
  //         setIsAuthenticated(true);
  //     } else {
  //         setError("Invalid OTP");
  //     }
  // };

  const handleVerifyOtp = async () => {
    if (!otp) {
      setError("Please enter OTP!");
      setShowErrorModal(true);
      return;
    }

    const storedHash = sessionStorage.getItem("otpHash");
    const expiry = sessionStorage.getItem("otpExpiry");

    if (!storedHash || Date.now() > expiry) {
      setError("OTP expired");
      setShowErrorModal(true);
      return;
    }

    const enteredHash = await hashOtp(otp);

    if (enteredHash === storedHash) {
      sessionStorage.removeItem("otpHash");
      sessionStorage.removeItem("otpExpiry");

      try {
        // ✅ Call backend API to create user and get token
        const response = await axios.post(`${BASE_URL}api/auth/signup_otp`, {
          email: email,
        });

        const { access_token, is_first_user } = response.data;

        // Store the token in session/local storage
        sessionStorage.setItem("access_token", access_token);
        sessionStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("first_time_user", is_first_user ? "True" : "False");
        setIsAuthenticated(true);
      } catch (err) {
        console.error(err);
        if (err.response && err.response.status === 409) {
          setError("Email already registered");
          setShowErrorModal(true);
        } else {
          setError("Failed to sign up. Try again.");
          setShowErrorModal(true);
        }
      }
    } else {
      setError("Invalid OTP");
      setShowErrorModal(true);
    }
  };

  const handleReEnterEmail = () => {
    setEmail("");
    setOtp("");
    setOtpSent(false);
    setError("");
    sessionStorage.removeItem("otpHash");
    sessionStorage.removeItem("otpExpiry");
  };

  // ✅ If already authenticated, redirect to welcome
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="otp-card">
      <h2 className="otp-title">Sign Up with OTP</h2>
      {/* {error && (
        <p style={{ color: "red", fontSize: "14px", marginLeft: "60px" }}>
          {error}
        </p>
      )} */}
      {/* Email Input */}
      <div className="otp-field">
        <input
          type="email"
          placeholder="Email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          disabled={otpSent} // ✅ disable after OTP is sent
        />
      </div>

      {/* Error Message */}
      {/* {error && <div className="alert alert-danger">{error}</div>} */}

      {/* Send OTP Button */}
      {!otpSent && (
        <button className="otp-btn" onClick={handleSendOtp}>
          Send OTP
        </button>
      )}

      {/* OTP Input and Verify Button */}
      {otpSent && (
        <>
          <div className="otp-field">
            <input
              type="text"
              placeholder="Enter OTP"
              maxLength="6"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
          </div>
          <div className="otp-btn-container">
            <button className="otp-btn-reenter" onClick={handleVerifyOtp}>
              Verify OTP
            </button>

            <button className="otp-btn-reenter" onClick={handleReEnterEmail}>
              Re-enter Email
            </button>
          </div>
        </>
      )}

      <ErrorModal
        show={showErrorModal}
        message={error}
        onClose={() => {
          setShowErrorModal(false);
          setError("");
        }}
      />

    </div>
  );
}

export default SignupOtp;
